import type { UpstreamRemote } from "@istari/istari-client";
import React from "react";

export interface RemotesOperationsValue {
  availableRemotes: UpstreamRemote[];
  isLoadingRemotes: boolean;

  selectedSources: string[];
  toggleSource: (sourceId: string) => void;
  selectAllSources: () => void;
  clearAllSources: () => void;
  isAllSourcesSelected: boolean;

  syncAll: () => void;
  syncSelected: () => void;
  syncRemote: (remoteId: string) => void;

  isInitiatingSyncAll: boolean;
  isSyncing: boolean;
  inProgressRemoteIds: string[];
  initiatingRemoteIds: string[];
  lastResultByRemoteId: Record<string, "completed" | "failed" | "cancel">;
}

export const RemotesOperationsContext = React.createContext<RemotesOperationsValue | undefined>(undefined);
